export default "__VITE_ASSET__db7a3a78__"